import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../firebase";

/**
 * Uploads a file to Firebase Storage and returns the public download URL.
 * 
 * @param {File|Blob} file The file to upload
 * @param {string} path The storage path (e.g., 'profile_pictures/user123.jpg')
 * @param {function} onProgress Optional callback for upload progress (0-100)
 * @returns {Promise<string>} The download URL
 */
export const uploadFile = async (file, path, onProgress = null) => {
    return new Promise((resolve, reject) => {
        const storageRef = ref(storage, path);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                if (onProgress) {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    onProgress(progress);
                }
            },
            (error) => {
                console.error("Upload failed:", error);
                reject(error);
            },
            async () => {
                try {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                } catch (error) {
                    reject(error);
                }
            }
        );
    });
};

/**
 * Deletes a file from Firebase Storage.
 * 
 * @param {string} path The storage path or download URL of the file to delete
 */
export const deleteFile = async (path) => {
    try {
        const storageRef = ref(storage, path);
        await deleteObject(storageRef);
        return true;
    } catch (error) {
        console.error("Delete failed:", error);
        throw error;
    }
};

/**
 * Generates a unique filename for audio recordings.
 */
export const generateAudioFilename = (userId) => {
    const timestamp = new Date().getTime();
    return `audio_recordings/${userId}/record_${timestamp}.webm`;
};
